import React, { useRef } from 'react';
import Classnames from 'classnames';
import InteractiveStatesButton from './InteractiveStatesButton';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {
    sendCustomClick
} from '../../../utils/SnowplowUtils';
import {
    buttonTypes,
    saveASeatSubCategory
} from '../../../constants/SnowplowConst';


function TicketRegistrationItem({id, ticketName, backgroundColor, disabled, active, tipText, onClick, loading}) {
    const cls = Classnames('tickets-registration-item',
        {'tickets-registration-item--disabled': disabled});
    const buttonAreaRef = useRef();
    const saveASeatSPHandler = () => {
        const subCategory = active
            ? saveASeatSubCategory.removeMultipleSaveASeatPopUp
            : saveASeatSubCategory.multipleSaveASeatPopUp;
        sendCustomClick(buttonTypes.saveSeat, subCategory, buttonAreaRef);
    };

    return (<div className={cls}>
        <div className="tickets-registration-item__body">
            <div className="tickets-registration-item__wrapper">
                <div className="tickets-registration-item__col1">
                    <div className="tickets-registration-item__name">{ticketName}</div>
                    <div className="tickets-registration-item__ticket tickets-registration-item__ticket--web">Ticket ID: #{id}</div>
                </div>
                <div className="tickets-registration-item__col2">
                    <div className="tickets-registration-item__ticket tickets-registration-item__ticket--mobile">Ticket ID: #{id}</div>
                    <div className="tickets-registration-item__button-wrapper">
                        <OverlayTrigger
                            delayShow={1000}
                            delayHide={100}
                            trigger={['hover', 'focus']}
                            placement="bottom"
                            overlay={<Tooltip id={`tip-ticket-${id}`}>{tipText}</Tooltip>}>
                            <div ref={buttonAreaRef}
                                onClick={saveASeatSPHandler}>
                                <InteractiveStatesButton
                                    disabled={disabled}
                                    active={active}
                                    backgroundColor={backgroundColor}
                                    text={active ? 'Seat saved!': 'Save a seat'}
                                    onClick={onClick}
                                    loading={loading}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
        </div>
    </div>);
}

export default TicketRegistrationItem;
